export default "__VITE_ASSET__BflHN02R__"